import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    drwotAcnInfo: {},
    param: {},
    selectRow: "",
    RBF1605AG0: {
      request: {},
      response: {},
    },
    completeView: {},
  };
};

const ovsesRmtancAplcnInfoInptReq = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {},
};

export default ovsesRmtancAplcnInfoInptReq;
